import script from "./FormViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormViewer.vue?vue&type=script&setup=true&lang=ts"

import "./FormViewer.vue?vue&type=style&index=0&id=bdca0d76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdca0d76"]])

export default __exports__